/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface DebtorReference {
  particulars: string;
  code: string;
  reference: string;
}

export const debtorReferenceSchema: Schema<DebtorReference> = object({
  particulars: ['Particulars', string()],
  code: ['Code', string()],
  reference: ['Reference', string()],
});
